import axios from 'axios';

const URL_API_TPV_COMS = process.env.VUE_APP_URL_API_TPV_COMS;
const URL_API_ALBARAN = process.env.VUE_APP_URL_API_ALBARAN;

export class AlbaranApiService {
 
  // modo: 'entrada' (default) or 'salida'
  getAlbaranesCab(opUid, modo = 'entrada') {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const endpoint = modo === 'salida' ? 'salidas' : 'entradas'
    const url = `${URL_API_TPV_COMS}${endpoint}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  // modo: 'entrada' (default) or 'salida'
  getBultos(opUid) {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const endpoint = 'entradas-bultos';
    const url = `${URL_API_TPV_COMS}${endpoint}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  // modo: 'entrada' (default) or 'salida'
  getAlbaranDetalle(opUid, uid, modo = 'entrada') {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const base = modo === 'salida' ? 'salidas' : 'entradas'
    const url = `${URL_API_TPV_COMS}${base}/${uid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  // modo: 'entrada' (default) or 'salida'
  getBultoDetalle(opUid, uid) {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const base = 'entradas-bultos';
    const url = `${URL_API_TPV_COMS}${base}/${uid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  enviarEntrada(entrada) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_ALBARAN}enviarEntrada`;
    return axios
      .post(url, entrada, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  enviarSalida(salida) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_ALBARAN}enviarSalida`;
    return axios
      .post(url, salida, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
}